import { render, staticRenderFns } from "./showHeader.vue?vue&type=template&id=28ed25c6"
import script from "./showHeader.vue?vue&type=script&lang=js"
export * from "./showHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports